<app-navbar variant="gdc"></app-navbar>
